import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEnhancedPageView } from '../utils/analytics';

// Hook to automatically track page views with React Router
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Use Navigation Timing API for accurate load duration, falling back to undefined
    let loadTime: number | undefined;
    try {
      const [navEntry] = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
      if (navEntry) {
        const ms = Math.round(navEntry.domContentLoadedEventEnd - navEntry.startTime);
        if (ms > 0) loadTime = ms;
      }
    } catch (_) {
      // Not available in all environments
    }

    // Track the page view
    trackEnhancedPageView(
      location.pathname + location.search,
      document.title,
      loadTime
    );
  }, [location]);
};

// Hook to track component mount/unmount times
export const useComponentTracking = (componentName: string) => {
  useEffect(() => {
    const startTime = performance.now();
    
    return () => {
      const loadTime = performance.now() - startTime;
      if (window.gtag && process.env.REACT_APP_GA_TRACKING_ID) {
        window.gtag('event', 'timing_complete', {
          name: `${componentName}_mount_time`,
          value: Math.round(loadTime),
          event_category: 'component_performance',
          event_label: componentName,
        });
      }
    };
  }, [componentName]);
};